import { camelCase, orderBy, kebabCase, compact } from 'lodash'
import { ReportSection } from '../../../types'
import { ConfigSection } from '../../../../../shared/types'
import { formatAnomalyForExport } from '../../../export/formatters'
import { getAnomalyDataSections } from '../../../utils/anomalies'

type AnomalySubSectionProps = {
  report: any
  reportUrl?: string
  history: any
  configSections?: ConfigSection[]
}

export default function getAnomalyList(props: AnomalySubSectionProps): ReportSection[] {
  const { report, configSections } = props
  const { reportMetadata, reportDetailData } = report

  const reportEndDate = reportMetadata.reportPeriod.endDate

  const anomalies = orderBy(reportDetailData.anomalies, ['anomalyName'], ['asc'])

  return (
    anomalies
      // remove anomaly types with no data and report anomalies
      .filter((anomaly) => anomaly.transactions?.length || anomaly.data?.length)
      .map((anomaly) => ({
        label: anomaly.anomalyName,
        value: camelCase(anomaly.anomalyName),
        route: kebabCase(anomaly.anomalyName),
        kind: 'anomaly',
        //data sections are configured here
        dataSections: getAnomalyDataSections({
          anomaly,
          context: 'table',
          configSections,
          reportEndDate,
        }),
        exportData: compact([formatAnomalyForExport(anomaly, reportEndDate, configSections)]),
      }))
  )
}
